// extracted by css-extract-rspack-plugin
export default {"reportGenerationV2Container":"gsNJsaW_p4Ezjcos","reportGenerationV2":"V1NEqAu_kAYufgie","sidebar":"b6nKKHuAQ1HJVTh0","filterSidebar":"kRg8g5SuLa002hrU"};